//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import axios from 'axios'

import jQuery from 'jquery';
import Cropper from 'cropperjs';

function debounced(fn, delay) {
    let timerId;
    return function (...args) {
        if (timerId) {
            clearTimeout(timerId);
        }
        timerId = setTimeout(() => {
            fn(...args);
            timerId = null;
        }, delay);
    }
}

function magnify(imgID, zoom) {
    var img, glass, w, h, bw, glass2, bgimgwidth, bgimgheight;
    img = document.getElementById(imgID);

    /* Create magnifier glass: */
    glass = document.createElement("DIV");
    glass.setAttribute("class", "img-magnifier-glass");

    glass2 = document.createElement("DIV");
    glass2.setAttribute("class", "img-magnifier-glass");

    /* Insert magnifier glass: */
    img.parentElement.insertBefore(glass, img);
    // insert also into original
    var leftImg = document.getElementById('original-preview');
    leftImg.parentElement.insertBefore(glass2, leftImg);

    let initialratio = img.naturalWidth / img.naturalHeight;

    let imgwidth = img.width
    let imgheight = img.height

    let displayratio = imgwidth / imgheight

    if (initialratio < displayratio) {
        bgimgwidth = imgheight * initialratio
        bgimgheight = imgheight
    } else {
        bgimgwidth = imgwidth
        bgimgheight = (imgwidth / initialratio)
    }

    /* Set background properties for the magnifier glass: */
    glass.style.backgroundImage = "url('" + img.src + "')";
    glass.style.backgroundRepeat = "no-repeat";
    //glass.style.backgroundSize = (bgimgwidth * zoom) + "px " + (bgimgheight * zoom) + "px";
    glass2.style.backgroundImage = "url('" + img.src + "')";
    glass2.style.backgroundRepeat = "no-repeat";
    //glass2.style.backgroundSize = (bgimgwidth * zoom) + "px " + (bgimgheight * zoom) + "px";
    bw = 3;
    w = glass.offsetWidth / 2;
    h = glass.offsetHeight / 2;

    /* Execute a function when someone moves the magnifier glass over the image: */
    glass.addEventListener("mousemove", moveMagnifier);
    img.addEventListener("mousemove", moveMagnifier);

    /*and also for touch screens:*/
    glass.addEventListener("touchmove", moveMagnifier);
    img.addEventListener("touchmove", moveMagnifier);

    function moveMagnifier(e) {
        var pos, x, y;
        /* Prevent any other actions that may occur when moving over the image */
        e.preventDefault();
        /* Get the cursor's x and y positions: */
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        var initX = pos.x;
        var initY = pos.y;
        /* Prevent the magnifier glass from being positioned outside the image: */
        if (x > imgwidth - (w / zoom)) {
            x = imgwidth - (w / zoom);
        }
        if (x < w / zoom) {
            x = w / zoom;
        }
        if (y > imgheight - (h / zoom)) {
            y = imgheight - (h / zoom);
        }
        if (y < h / zoom) {
            y = h / zoom;
        }
        /* Set the position of the magnifier glass: */
        glass.style.left = (x - w) + "px";
        glass.style.top = (y - h) + "px";

        glass2.style.left = (x - w) + "px";
        glass2.style.top = (y - h) + "px";
        /* Display what the magnifier glass "sees": */
        // hack of the background position
        var backx = (initX / imgwidth) * 100;
        var backy = (initY / imgheight) * 100;
        glass.style.backgroundPosition = backx + '% ' + backy + '%';
        glass2.style.backgroundPosition = backx + '% ' + backy + '%';
    }

    function getCursorPos(e) {
        var a, x = 0, y = 0;
        e = e || window.event;
        /* Get the x and y positions of the image: */
        a = img.getBoundingClientRect();
        /* Calculate the cursor's x and y coordinates, relative to the image: */
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /* Consider any page scrolling: */
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x: x, y: y};
    }
}

export default {
    name: 'WatermarkingDemo',
    data() {
        return {
            step: 1,
            dragging: false,
            originalUploaded: false,
            cropper: null,
            grayscale: false,
            lmk: null,
            quality: 90,
            resolution: 100,
            toggleQuality: false,
            marked: null,
            marksearch: false,
            modifiedInfos: null,
            timerId: null,
            document: document
        }
    },
    mounted() {
        axios.defaults.baseURL = 'https://imatag.com/api/v2/';
        axios.defaults.headers.common['Authorization'] = 'Token fd8fef6e430595edc3bab691d9a83230f0a56b99';
    },
    computed: {
        pattern: function () {
            return `step-${this.step}`;
        },
        titleStep: function () {
            const titles = {
                1: 'Upload an image to watermark it.',
                2: 'Our IMATAG technology inserts an invisible watermark on the image.',
                3: 'You share your watermarked image, which is potentially reused, modified, and published on the internet.',
                4: 'You share your watermarked image, which is potentially reused, modified, and published on the internet.'
            }
            return titles[this.step]
        }
    },
    methods: {
        clickNext() {
            if (this.step === 2) {
                this.step = 3
            } else {
                this.detection()
            }
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`
        },
        clickPrevious() {
            if (this.step === 3) {
                this.resetStep2()
            } else {
                this.resetStep3()
            }
            console.log(this.step)
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`
        },
        markImage: function (ev) {
            let file = null
            if (document.querySelector('#file').files.length) {
                // file is coming from input
                file = document.querySelector('#file').files[0];
            } else {
                // file is coming from drop
                ev.preventDefault()
                if (ev.dataTransfer.items[0].kind === 'file') {
                    file = ev.dataTransfer.items[0].getAsFile();
                } else {
                    alert('Invalid file provided');
                }
            }
            if (file.type !== 'image/jpeg') {
                alert('Unsupported file type, please use jpg file');
                this.resetStep1();
                return;
            }
            // display of the uploaded file
            var output = document.getElementById('original-preview');
            output.src = URL.createObjectURL(file);
            this.originalUploaded = true;
            // mark the image
            if (file) {
                axios.post(`/watermarking/`, file, {
                    headers: {
                        'Content-Type': file.type
                    }
                })
                    .then(response => {
                        this.step = 2;
                        let mpreview = document.querySelector('#marked-preview');
                        mpreview.src = response.data.watermarked;
                        this.lmk = response.data.registration;
                        let cpreview = document.querySelector('#cropped-preview');
                        if (cpreview) {
                            cpreview.src = response.data.watermarked;
                        }
                        setTimeout(() => {
                            magnify('marked-preview', 2);
                            // crop next step
                            const image = document.getElementById('cropped-preview');
                            var self = this;
                            this.cropper = new Cropper(image, {
                                viewMode: 3,
                                checkOrientation: false,
                                ready(event) {
                                    document.querySelector('.cropper-view-box').innerHTML = '';
                                    let data = this.cropper.getCropBoxData();
                                    let width = data.width;
                                    let canvas = this.cropper.getCroppedCanvas({
                                        width: width
                                    });
                                    let img = document.createElement('img');
                                    img.src = canvas.toDataURL();
                                    document.querySelector('.cropper-view-box').append(img);
                                },
                                crop(event) {
                                    self.drawCroppedImage();
                                },
                                cropend(event) {
                                    if (self.step === 4) {
                                        self.detection()
                                    }
                                },
                                zoom(event) {
                                    if (self.step === 4) {
                                        self.detection()
                                    }
                                }
                            });
                        }, 200)
                    })
            }
        },
        drawCroppedImage: function () {
            let data = this.cropper.getCropBoxData();
            let width = data.width * (this.resolution / 100);
            let originalinfos = this.cropper.getCroppedCanvas();
            let infos = this.cropper.getCroppedCanvas({
                width: originalinfos.width * (this.resolution / 100)
            })
            let canvas = this.cropper.getCroppedCanvas({
                width: width
            });
            var ctx = canvas.getContext("2d");
            // filters on the canvas
            if (this.grayscale) {
                var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                var dataImg = imageData.data;
                for (var i = 0; i < dataImg.length; i += 4) {
                    var brightness = 0.34 * dataImg[i] + 0.5 * dataImg[i + 1] + 0.16 * dataImg[i + 2];
                    dataImg[i] = dataImg[i + 1] = dataImg[i + 2] = brightness;
                }
                ctx.putImageData(imageData, 0, 0);
            }
            let newImage = canvas.toDataURL('image/jpeg', (this.quality / 100));
            let fakeImage = infos.toDataURL('image/jpeg', (this.quality / 100));
            infos.size = this.bytes(fakeImage.split(',')[1].length * 6 / 8);
            this.modifiedInfos = `${infos.width} × ${infos.height} - ${infos.size}`;
            document.querySelector('.cropper-view-box img').src = newImage;
            if (this.step === 4) {
                this.detection();
            }
        },
        detection: function () {
            this.step = 4;
            this.marksearch = true;
            let pattern = document.querySelector('.pattern')
            pattern.classList.remove('green');
            pattern.classList.remove('red');
            this.marked = null;
            let originalinfos = this.cropper.getCroppedCanvas();
            let canvas = this.cropper.getCroppedCanvas({
                width: originalinfos.width * (this.resolution / 100)
            });
            var ctx = canvas.getContext("2d");
            // filters on the canvas
            if (this.grayscale) {
                var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                var dataImg = imageData.data;
                for (var i = 0; i < dataImg.length; i += 4) {
                    var brightness = 0.34 * dataImg[i] + 0.5 * dataImg[i + 1] + 0.16 * dataImg[i + 2];
                    dataImg[i] = dataImg[i + 1] = dataImg[i + 2] = brightness;
                }
                ctx.putImageData(imageData, 0, 0);
            }
            let detectImage = canvas.toDataURL('image/jpeg', (this.quality / 100));
            document.querySelector('#detect-preview').src = detectImage;
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
            this.timerId = setTimeout(() => {
                this.callDetection(canvas)
            }, 2000);
        },
        callDetection: function (canvas) {
            canvas.toBlob(blob => {
                axios.post('/uploads/', blob, {
                    headers: {
                        'Content-Type': 'image/jpeg'
                    }
                })
                    .then(response => {
                        let query = response.data.url;
                        let lmk = this.lmk;
                        axios.post('/watermarking/detect/', {
                            query: query,
                            registration: lmk
                        })
                            .then(response => {
                                let pattern = document.querySelector('.pattern')
                                pattern.classList.remove('green');
                                pattern.classList.remove('red');
                                this.marked = response.data.marked;
                                this.marksearch = false
                                if (this.marked) {
                                    pattern.classList.add('green')
                                } else {
                                    pattern.classList.add('red')
                                }
                            })
                    })
            }, 'image/jpeg', (this.quality / 100))
        },
        resetStep1: function () {
            if (!this.originalUploaded) {
                return;
            }
            this.originalUploaded = false;
            document.getElementById('original-preview').removeAttribute('src');
            document.getElementById('marked-preview').removeAttribute('src');
            document.querySelectorAll('.img-magnifier-glass').forEach(e => e.parentNode.removeChild(e));
            if (this.cropper) {
                this.cropper.destroy();
            }
            this.resetStep2();
            this.resetStep3();
            this.step = 1;
            const steps = document.querySelector('.steps')
            steps.style.transform = `translateX(0px)`
        },
        resetStep2: function () {
            this.resetStep3();
            this.step = 2;
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`
        },
        resetStep3: function () {
            this.step = 3;
            const step = document.querySelector('.step');
            const steps = document.querySelector('.steps')
            const {width} = step.getBoundingClientRect()
            steps.style.transform = `translateX(-${(this.step - 2) * width}px)`
        },
        bytes: function (bytes, si) {
            var unit = si ? 1000 : 1024;
            if (bytes < unit) return bytes + " B";
            var exp = Math.floor(Math.log(bytes) / Math.log(unit));
            var pre = (si ? "kMGTPE" : "KMGTPE").charAt(exp - 1) + (si ? "" : "i");
            return (bytes / Math.pow(unit, exp)).toFixed(1) + " " + pre + "B";
        },
    }
}



// WEBPACK FOOTER //
// ./scripts/demo/WatermarkingDemo.vue